export enum ClubType{
    CLUB = 1,
    EVENT = 2,
    RSVP = 3,
}